import { whenAgentIdle } from '../whenAgentIdle';
export function sendMessageToThread(agent, text) {
  var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  whenAgentIdle(agent, function () {
    var _agent$sendMessage;
    return agent === null || agent === void 0 || (_agent$sendMessage = agent.sendMessage) === null || _agent$sendMessage === void 0 ? void 0 : _agent$sendMessage.call(agent, text, {
      silent: silent
    });
  });
}